import RelatedDocumentsBody from './RelatedDocumentsBody'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selectedRegionId,
    regionsData: state.REGIONS.regionsData
  }
}

export default withRouter(connect(mapStateToProps)(RelatedDocumentsBody))



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBody/index.js